import "./Home.css";
import React, { useEffect, useState } from "react";
import {db} from "../../config/firebaseConfig";
import { collection, getDocs, query, where } from "firebase/firestore";

const Home=()=>{
    const [data, setData] = useState([]); // Firestore データを保存する状態
    const [loading, setLoading] = useState(true); // ローディング状態
    const currentProjectID = localStorage.getItem("currentProjectID");

    // Firestore データを取得する関数
    const fetchData = async () => {
    try {

        const q = query(
            collection(db, "posts"),
            where("projectID", "==", currentProjectID)
        );        
        const querySnapshot = await getDocs(q);            
        const items = [];
        querySnapshot.forEach((doc) => {
          items.push({ id: doc.id, ...doc.data() }); // データとドキュメント ID を取得
        });
        setData(items); // 状態にデータをセット
        setLoading(false); // ローディング完了
    } catch (error) {
        console.error("Error fetching Firestore data: ", error);
        setLoading(false);
        }
    };  
    useEffect(() => {
      fetchData(); // コンポーネントのマウント時にデータを取得
    }, []);

    if (loading) {
      return <p>Loading...</p>; // ローディング中の表示
    }

    return <div className="homePage">
        {data.map((item) =>{
            return(
                <div class="postContents" key={item.id}>
                <div class="postheader">
                    <h1>{item.title}</h1>
                </div>
                <div class="postTextContainer">
                    {item.postText}
                </div>
                <div class="nameAndDeleteButton">
                    <h3>@{item.auther.username}</h3>
                    <button>削除</button>
                </div>n
            </div>
            )
        })};
    </div>;
};

export default Home;